import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

const YEAR = new Date().getFullYear();

const SOCIAL = [
  { href: "https://www.facebook.com/SativaSystems/", label: "Facebook", Icon: Facebook },
  { href: "https://www.instagram.com/sativa_building_systems/", label: "Instagram", Icon: Instagram },
  { href: "https://www.linkedin.com/company/sativa-building-systems/", label: "LinkedIn", Icon: Linkedin },
  { href: "https://www.youtube.com/@sativabuildingsystems3796", label: "YouTube", Icon: Youtube },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1D1A] text-[#F4F3EF] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#C9B07A] flex items-center justify-center">
                <span className="font-display font-black text-[#1A1D1A] text-lg leading-none">S</span>
              </div>
              <div className="leading-tight">
                <div className="font-display font-bold text-base text-[#F4F3EF] tracking-tight">
                  Sativa Construction
                </div>
                <div className="text-[10px] tracking-[0.22em] uppercase text-[#C9B07A]">
                  Building Systems
                </div>
              </div>
            </div>
            <p className="font-body text-[#F4F3EF]/65 mt-6 text-sm leading-relaxed max-w-md">
              Residential general contracting for Central Wisconsin homeowners
              who care about how their home is built. Safe, sustainable,
              superior craft.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#C9B07A] font-bold">
              Contact
            </div>
            <ul className="mt-5 space-y-3 text-sm font-body text-[#F4F3EF]/85">
              <li>
                <a href="tel:+17154700677" data-testid="footer-phone" className="hover:text-[#C9B07A] transition-colors">
                  715-470-0677
                </a>
              </li>
              <li>
                <a
                  href="mailto:zach@sativapanel.com"
                  data-testid="footer-email"
                  className="hover:text-[#C9B07A] transition-colors break-all"
                >
                  zach@sativapanel.com
                </a>
              </li>
              <li className="text-[#F4F3EF]/65">Central Wisconsin</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#C9B07A] font-bold">
              Sativa Building Systems
            </div>
            <p className="font-body text-[#F4F3EF]/65 mt-5 text-sm leading-relaxed">
              Visit our parent site to learn about the patented Z Panel and our
              non-toxic tiny home line.
            </p>
            <a
              href="https://sativabuildingsystems.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-parent-link"
              className="inline-block mt-4 text-sm font-semibold text-[#C9B07A] border-b border-[#C9B07A] pb-0.5 hover:text-white hover:border-white transition-colors"
            >
              sativabuildingsystems.com →
            </a>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div className="text-xs text-[#F4F3EF]/55 font-body">
            © {YEAR} Sativa Building Systems. All rights reserved.
          </div>
          <div className="flex items-center gap-4">
            {SOCIAL.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="w-10 h-10 border border-white/15 flex items-center justify-center text-[#F4F3EF]/70 hover:text-[#1A1D1A] hover:bg-[#C9B07A] hover:border-[#C9B07A] transition-all duration-300"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
